var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 100,
    viewBox: "0 0 98 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9691 64.5834L20.417 66.6667C20.417 71.2251 22.1916 75.5968 25.3504 78.8201C28.5092 82.0434 32.7935 83.8542 37.2607 83.8542H40.8337V78.6459H37.2607C34.1472 78.6459 31.1612 77.3838 28.9596 75.1373C26.758 72.8907 25.5212 69.8438 25.5212 66.6667L22.9691 64.5834Z",
    fill: "url(#paint0_linear_4569_338)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2087 81.25C59.2087 84.0127 58.1331 86.6622 56.2187 88.6157C54.3043 90.5692 51.7077 91.6667 49.0003 91.6667C46.2929 91.6667 43.6964 90.5692 41.7819 88.6157C39.8675 86.6622 38.792 84.0127 38.792 81.25C38.792 78.4874 39.8675 75.8378 41.7819 73.8843C43.6964 71.9308 46.2929 70.8334 49.0003 70.8334C51.7077 70.8334 54.3043 71.9308 56.2187 73.8843C58.1331 75.8378 59.2087 78.4874 59.2087 81.25Z",
    fill: "url(#paint1_linear_4569_338)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5212 37.5C25.5212 24.2688 36.0337 13.5417 49.0003 13.5417C61.967 13.5417 72.4795 24.2688 72.4795 37.5V41.6667L74.5212 44.7917L77.5837 41.6667V37.5C77.5837 21.3917 64.7865 8.33337 49.0003 8.33337C33.2142 8.33337 20.417 21.3917 20.417 37.5V41.6667L23.4795 44.7917L25.5212 41.6667V37.5Z",
    fill: "url(#paint2_linear_4569_338)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5215 41.6667H36.2402C37.4586 41.6667 38.627 42.1606 39.4885 43.0397C40.35 43.9188 40.834 45.111 40.834 46.3542V61.9792C40.834 62.5948 40.7152 63.2044 40.4843 63.7731C40.2535 64.3418 39.9151 64.8585 39.4885 65.2938C39.0619 65.7291 38.5555 66.0744 37.9982 66.3099C37.4408 66.5455 36.8435 66.6667 36.2402 66.6667H25.5215L22.459 54.1667L25.5215 41.6667Z",
    fill: "url(#paint3_linear_4569_338)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4795 65.8834L75.542 53.7751L72.4795 41.6667H61.7607C60.5424 41.6667 59.374 42.1606 58.5125 43.0397C57.651 43.9188 57.167 45.111 57.167 46.3542V61.9792C57.167 63.2224 57.651 64.4147 58.5125 65.2938C59.374 66.1729 60.5424 66.6667 61.7607 66.6667H68.9066C70.1806 66.6667 71.3892 66.3876 72.4795 65.8834Z",
    fill: "url(#paint4_linear_4569_338)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5212 41.6667H20.417V66.6667H25.5212V41.6667Z",
    fill: "url(#paint5_linear_4569_338)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4795 65.8834C74.0011 65.1819 75.292 64.0472 76.1973 62.6157C77.1027 61.1841 77.5841 59.5164 77.5837 57.8126V41.6667H72.4795V65.8834Z",
    fill: "url(#paint6_linear_4569_338)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4569_338",
    x1: 32.326,
    y1: 80.6417,
    x2: 26.3181,
    y2: 64.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70777D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4569_338",
    x1: 56.6566,
    y1: 89.0625,
    x2: 39.1856,
    y2: 79.0617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70777D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4569_338",
    x1: 0.000325192,
    y1: 8.33337,
    x2: 7.11531,
    y2: 38.2511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70777D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4569_338",
    x1: 49.0007,
    y1: 41.6667,
    x2: 49.0007,
    y2: 66.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0067BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4569_338",
    x1: 49.0003,
    y1: 41.6667,
    x2: 49.0003,
    y2: 66.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0067BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4569_338",
    x1: 49.0003,
    y1: 41.6667,
    x2: 48.4009,
    y2: 66.6516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2052CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4569_338",
    x1: 49.0003,
    y1: 41.6667,
    x2: 48.4008,
    y2: 66.6516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2052CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.c91efcbeb6daacdaab7f58748a6e67cb.svg";
export { ForwardRef as ReactComponent };